import { render, staticRenderFns } from "./BoxWordStatisticsQuizChart.vue?vue&type=template&id=4addc8ec&"
import script from "./BoxWordStatisticsQuizChart.vue?vue&type=script&lang=js&"
export * from "./BoxWordStatisticsQuizChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports